// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","addIcon":"styles_addIcon__4KYdO","container":"styles_container__FYFTb","error":"styles_error__uAxlE"};